module.exports = __webpack_public_path__ + "static/media/Image_25.c10c400d.png";